import {
  Millwright,
  MillwrightApiResponse,
  MillwrightOutage,
  MillwrightOutageApiResponse,
  MillwrightKPI,
  MillwrightKpiResultApiResponse,
  MillwrightModelResultsApiResponse,
} from '@/apis/millwrights/types/millwrightsApi';
import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';
import { getMillwrightFullName } from '@/utils';

export const outageFromApiAdapter = (
  outage: MillwrightOutageApiResponse,
): MillwrightOutage => {
  return {
    outageId: outage.OutageID,
    outageName: outage.OutageName,
  };
};

export const millwrightFromApiAdapter = (
  millwright: MillwrightApiResponse,
): Millwright => {
  const firstName = millwright?.FirstNameActual ?? millwright?.FirstName ?? '';
  const lastName = millwright?.LastNameActual ?? millwright?.LastName ?? '';

  return {
    empId: millwright.EmpID,
    birthday: millwright.Birthday,
    city: millwright.City,
    state: millwright.State,
    firstName,
    lastName,
    fullName: getMillwrightFullName(
      firstName,
      lastName,
      millwright?.MiddleInitial ?? '',
    ),
    riskScore: millwright.RiskScore ? millwright.RiskScore * 100 : 0,
    jobTitleEx: millwright.JobTitleEx ?? null,
    riskDate: millwright.RiskDate ?? '',
    dt: millwright.DT ?? null,
    ot: millwright.OT ?? null,
    rt: millwright.RT ?? null,
    total: millwright.Total ?? null,
    photoData: millwright.PhotoData ?? '',
    hasPhoto: millwright.HasPhoto ?? false,
    nGlobal: millwright.NGlobal,
    minScoreGlobal: millwright.MinScoreGlobal,
    maxScoreGlobal: millwright.MaxScoreGlobal,
    globalPercentile: millwright.GlobalPercentile ?? 0,
    globalNormalized0_100: millwright.GlobalNormalized0_100 ?? 0,
    ...(millwright.TaskID && { taskID: millwright.TaskID }),
    ...(millwright.TaskDescription && {
      taskDescription: millwright.TaskDescription,
    }),
    ...(millwright.Outages && {
      outages: millwright.Outages.map(outageFromApiAdapter),
    }),
  };
};

export const outageMillwrightsFromApiAdapter = (
  response: PaginatedResponseFromApi<MillwrightApiResponse>,
): PaginatedResponse<Millwright> => {
  return {
    results: response?.results.map(millwrightFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};

export const millwrightKpiFromApiAdapter = (
  kpi: MillwrightKpiResultApiResponse,
): MillwrightKPI => {
  return {
    kpiId: kpi.KpiID,
    kpiRank: kpi.KpiRank,
    kpiName: kpi.KpiName,
    kpiDescription: kpi.KpiDescription,
    kpiValue: kpi.KpiValue,
  };
};

export const millwrightKpisFromApiAdapter = (
  response: MillwrightModelResultsApiResponse,
): MillwrightKPI[] => {
  return response?.Results?.map(millwrightKpiFromApiAdapter) ?? [];
};
